import { Injectable, inject } from '@angular/core';
import { CaseAuthorizationState } from '../../states/case-authorization.state';
import { CasePermission } from '../../../domain/enums/case-permission.enum';

/**
 * Use case for checking if the current user has a specific case permission.
 * Checks against the permissions stored in CaseAuthorizationState.
 */
@Injectable({ providedIn: 'root' })
export class HasCasePermissionUseCase {
  private readonly state = inject(CaseAuthorizationState);

  /**
   * Checks if the current user has the specified case permission.
   *
   * @param permission - The case permission to check
   * @returns True if the user has the permission, false otherwise
   */
  public execute(permission: CasePermission): boolean {
    return this.state.hasPermission(permission);
  }
}
